/**
 * Custom hook to detect clicks outside a referenced element.
 *
 * Useful for closing dropdowns, modals, and menus when the user
 * clicks elsewhere.
 *
 * Cross-References:
 *   - FR-UI-002: Profile dropdown close-on-click-outside
 */
import { useEffect, type RefObject } from 'react';

export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  handler: () => void,
): void {
  useEffect(() => {
    function onMouseDown(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        handler();
      }
    }
    document.addEventListener('mousedown', onMouseDown);
    return () => document.removeEventListener('mousedown', onMouseDown);
  }, [ref, handler]);
}
